export default __webpack_public_path__ + "static/media/open-source-oval.ec0ef457.svg";